import { render, staticRenderFns } from "./CommpanyBrandList.vue?vue&type=template&id=ced94cfc&"
import script from "./CommpanyBrandList.vue?vue&type=script&lang=js&"
export * from "./CommpanyBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports